import Vue from 'vue'
import {router} from '../routes/Router'
import store from '../data/AppData'

// login urls
const IS_LOCAL = process.env.NODE_ENV !== 'production'
const API_BASE_URL = IS_LOCAL ? 'http://localhost:9000/' : ''
const LOGIN_URL = API_BASE_URL + 'login'
const REFRESH_URL = API_BASE_URL + 'refresh'
// const LOGOUT_URL = API_BASE_URL + 'logout'
// const REFRESH_URL = "refresh"

export default {
	loginAttempted: false,
	refresh (next) {
		this.loginAttempted = true
		let token = localStorage.getItem('id_token')

		if (token) {
			return Vue.http.get(REFRESH_URL, {
				headers: this.getAuthHeader()
			}).then((response) => {
				localStorage.setItem('id_token', response.body.access_token)
				store.commit('setLoggedIn', response.body.display_name)
				next()
			}, (response) => {
				this.logout()
				next()
			})
		} else {
			next()
		}
	},
	// Send a request to the login URL and save the returned JWT
	login (context, creds, redirect = '/') {
		this.loginAttempted = true
		context.$http.post(LOGIN_URL, creds).then((response) => {
			// success callback
			localStorage.setItem('id_token', response.body.access_token)
			store.commit('setLoggedIn', response.body.display_name)
			if (redirect) {
				console.log('Should go')
				router.push(redirect)
			}
		}, (response) => {
			// error callback
			context.error = response.body
			context.formSubmitted = false
		})
	},

	// To log out
	logout () {
		console.log('logout')
		localStorage.removeItem('id_token')
		store.commit('setLoggedOut')
		router.push('/login')
	},
	getAuthHeader () {
		return {
			'Authorization': 'Bearer ' + localStorage.getItem('id_token')
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/auth.js